import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Footer, Navbar, ProtectedRoute, Sidebar, ThemeSettings } from "./components";
import {
  Area,
  Auteurs,
  Auth,
  Bar,
  Calendar,
  ColorMapping,
  ColorPicker,
  Customers,
  Ecommerce,
  Editor,
  Employees,
  Financial,
  Kanban,
  Line,
  Orders,
  Pie,
  Profile,
  Pyramid,
  Redevances,
  Stacked,
  Users
} from "./pages";

import { useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import { useStateContext } from "./contexts/ContextProvider";
import GestionAdresses from "./pages/GestionAdresses";
import GestionEvenements from "./pages/GestionEvenements";
import GestionUsagers from "./pages/GestionUsagers";
import UsagerPayments from "./pages/UsagerPayments";
import ChangePassword from "./pages/ChangePassword";
import Report from "./pages/Report";
import ReportDetail from "./pages/ReportDetail";
import UsagerDetails from "./pages/UsagerDetails";

const App = () => {
  const { activeMenu, themeSettings, setThemeSettings, currentColor, currentMode } = useStateContext();
  const token = useSelector((state) => state?.auth ? state.auth : JSON.parse(localStorage.getItem('auth')))
  console.log('le token', token)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

 
  useEffect(() => {
    setIsAuthenticated(token ? true : false)

  }, [token])


  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <BrowserRouter>
        <div className="flex relative dark:bg-main-dark-bg">
          {/* Bouton des paramètres */}
          <div className="fixed right-4 bottom-4" style={{ zIndex: "1000" }}>
            <TooltipComponent content="Settings" position="Top">
              <button
                type="button"
                className="text-3xl p-3 hover:drop-shadow-xl hover:bg-light-gray text-white"
                onClick={() => setThemeSettings(true)}
                style={{ background: currentColor, borderRadius: "50%" }}
              >
                <FiSettings />
              </button>
            </TooltipComponent>
          </div>

          {/* Sidebar */}
          {isAuthenticated && (
            <div className={`${activeMenu ? "w-72" : "w-0"} fixed sidebar dark:bg-secondary-dark-bg bg-white transition-all duration-300`}>
              <Sidebar />
            </div>
          )}

          {/* Contenu principal */}
          <div
            className={`dark:bg-main-dark-bg bg-main-bg min-h-screen w-full transition-all duration-300 ${isAuthenticated && activeMenu ? "md:ml-72" : "flex-2"
              }`}
          >
            {/* Navbar */}
            {isAuthenticated && (
              <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
                <Navbar />
              </div>
            )}

            <ToastContainer />

            {/* Paramètres de thème */}
            {themeSettings && <ThemeSettings />}

            {/* Routes */}
            <Routes>
              {/* Authentification */}
              <Route path="/auth" element={<Auth />} />
              <Route path="/usagerPay" element={<UsagerPayments />} />

              {/* Routes protégées */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Ecommerce />} />
                <Route path="/dashboard" element={<Ecommerce />} />
                <Route path="/changepass" element={<ChangePassword />} />

                {/* Pages */}
                <Route path="/paiements" element={<Orders />} />
                <Route path="/auteurs" element={<Auteurs />} />
                <Route path="/usagers" element={<Employees />} />
                <Route path="/usager/:id" element={<UsagerDetails />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/redevances" element={<Redevances />} />
                <Route path="/redevances/:name" element={<Redevances />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/utilisateurs" element={<Users />} />
                <Route path="/rapports" element={<Report />} />
                <Route path="/rapports/:id" element={<ReportDetail />} />

                {/* Apps */}
                <Route path="/kanban" element={<Kanban />} />
                <Route path="/editor" element={<Editor />} />
                <Route path="/evenements" element={<Calendar />} />
                <Route path="/gestUsagers" element={<GestionUsagers />} />
                <Route path="/gestAdresses" element={<GestionAdresses />} />
                <Route path="/gestEvents" element={<GestionEvenements />} />
                <Route path="/color-picker" element={<ColorPicker />} />

                {/* Graphiques */}
                <Route path="/line" element={<Line />} />
                <Route path="/area" element={<Area />} />
                <Route path="/bar" element={<Bar />} />
                <Route path="/pie" element={<Pie />} />
                <Route path="/financial" element={<Financial />} />
                <Route path="/color-mapping" element={<ColorMapping />} />
                <Route path="/pyramid" element={<Pyramid />} />
                <Route path="/stacked" element={<Stacked />} />
              </Route>
            </Routes>
          </div>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
